let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kJcWg")).then(() => parcelRequire('lLg7I'));